import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import {
  PRODUCT_FORECAST,
  PRODUCT_PERFORMANCE,
  STOCK_ANALYSIS,
  TOP_DEALERS,
} from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*---------------- Stock Analysis ---------------- */
export const StockAnalysisAPI = createAsyncThunk(
  "stock-analysis/admin",
  async (reqData) => {
    try {
      const response = await getApi(
        `${STOCK_ANALYSIS}?year=${reqData.year}&quarter=${reqData.quarter}&page=${reqData.page}&per_page=${reqData.perPage}`,
      );
      console.log("Stock Analysis response is:", response);
      return response;
    } catch (error) {
      console.log("Error Stock Analysis API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- Stock Analysis Export ---------------- */
export const StockAnalysisExportAPI = createAsyncThunk(
  "stock-analysis/admin",
  async (reqData) => {
    try {
      const response = await getApi(
        `${STOCK_ANALYSIS}/export?year=${reqData.year}&quarter=${reqData.quarter}`,
      );
      console.log("Stock Analysis Export response is:", response);
      return response;
    } catch (error) {
      console.log("Error Stock Analysis Export API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- PRODUCT PERFORMANCE ---------------- */
export const ProductPerformanceAPI = createAsyncThunk(
  "product-performance/admin",
  async (reqData) => {
    try {
      const response = await getApi(
        `${PRODUCT_PERFORMANCE}?year=${reqData.year}&quarter=${reqData.quarter}&page=${reqData.page}&sort=${reqData.sort}&per_page=${reqData.perPage}`,
      );
      console.log("ProductPerformanceAPI response is:", response);
      return response;
    } catch (error) {
      console.log("Error ProductPerformanceAPI API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- PRODUCT PERFORMANCE EXPORT ---------------- */
export const ProductPerformanceExportAPI = createAsyncThunk(
  "product-performance-export/admin",
  async (reqData) => {
    try {
      const response = await getApi(
        `${PRODUCT_PERFORMANCE}/export?year=${reqData.year}&quarter=${reqData.quarter}&sort=${reqData.sort}`,
      );
      console.log("ProductPerformanceExportAPI response is:", response);
      return response;
    } catch (error) {
      console.log("Error ProductPerformanceExportAPI API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- PRODUCT FORECAST ---------------- */
export const ProductForecastAPI = createAsyncThunk(
  "product-forecast/admin",
  async (reqData) => {
    try {
      const response = await postApi(PRODUCT_FORECAST, reqData);
      console.log("ProductForecastAPI response is:", response);
      return response;
    } catch (error) {
      console.log("Error ProductForecastAPI API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- PRODUCT FORECAST EXPORT ---------------- */
export const ProductForecastExportAPI = createAsyncThunk(
  "product-forecast-export/admin",
  async (reqData) => {
    try {
      const response = await postApi(`${PRODUCT_FORECAST}/export`, reqData);
      console.log("ProductForecastExportAPI response is:", response);
      return response;
    } catch (error) {
      console.log("Error ProductForecastExportAPI API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- TOP DEALERS ---------------- */
export const TopDealersAPI = createAsyncThunk(
  "top-dealers/admin",
  async (reqData) => {
    try {
      const response = await postApi(TOP_DEALERS, reqData);
      console.log("TopDealersAPI response is:", response);
      return response;
    } catch (error) {
      console.log("Error TopDealersAPI API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

/*---------------- TOP DEALERS EXPORT ---------------- */
export const TopDealersExportAPI = createAsyncThunk(
  "top-dealers-export/admin",
  async (reqData) => {
    try {
      const response = await postApi(`${TOP_DEALERS}/export`, reqData);
      console.log("TopDealersExportAPI response is:", response);
      return response;
    } catch (error) {
      console.log("Error TopDealersExportAPI API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);
